import { useQuery } from '@tanstack/react-query';
import { adminKeys, fileApi } from '../features/admin/api';

export interface UploadsState {
  /** `undefined` khi chưa biết — đừng bật nút trước khi biết chắc. */
  readonly enabled: boolean | undefined;
  readonly reason: string | null;
  readonly maxBytes: number;
  readonly allowedMimeTypes: readonly string[];
}

/**
 * Nút tải lên có bật được không, và **vì sao không**.
 *
 * Lý do đến từ server chứ không suy ra ở client: `StorageService` mới là nơi
 * biết đủ điều kiện (có config, config đã verified, đã kích hoạt). Để mỗi màn
 * hình tự suy từ một lời gọi khác là mỗi nơi suy một kiểu, và cái suy sai sẽ
 * là cái không ai test.
 *
 * ⚠️ Đây là tiện lợi cho người dùng, **không phải bảo mật**: chặn thật nằm ở
 * `presignUpload` phía server, nơi trả `STORAGE_NOT_CONFIGURED`.
 */
export function useUploadsEnabled(): UploadsState {
  const capabilities = useQuery({
    queryKey: adminKeys.capabilities,
    queryFn: fileApi.capabilities,
    // Cấu hình lưu trữ hiếm khi đổi; hỏi lại mỗi 5 phút là đủ.
    staleTime: 5 * 60_000,
  });

  return {
    // `undefined` trong lúc đang tải: bật nút rồi mới biết là chưa cấu hình
    // sẽ cho người dùng chọn xong file mới báo lỗi.
    enabled: capabilities.data?.uploadsEnabled,
    reason: capabilities.data?.disabledReason ?? null,
    maxBytes: capabilities.data?.maxBytes ?? 0,
    allowedMimeTypes: capabilities.data?.allowedMimeTypes ?? [],
  };
}
